import React from "react";
import { Colors } from "@blueprintjs/core";
import styled, { css } from "styled-components";

const Badge = styled.span`
  display: inline-block;
  border-radius: 9px;
  width: 18px;
  height: 18px;
  line-height: 18px;
  font-size: 12px;
  color: ${Colors.WHITE};
  text-align: center;
  ${({ score }) => {
    if (score <= 20)
      return css`
        background: ${Colors.RED2};
      `;
    if (score > 20 && score <= 40)
      return css`
        background: ${Colors.ORANGE2};
      `;
    if (score > 40 && score <= 60)
      return css`
        background: ${Colors.LIME2};
      `;
    if (score > 60 && score <= 80)
      return css`
        background: ${Colors.FOREST2};
      `;
    if (score > 80 && score <= 100)
      return css`
        background: ${Colors.GREEN2};
      `;
  }};
`;

function convertScoreToGrade(score) {
  if (score <= 20) return "E";
  if (score > 20 && score <= 40) return "D";
  if (score > 40 && score <= 60) return "C";
  if (score > 60 && score <= 80) return "B";
  if (score > 80 && score <= 100) return "A";
}

export default function ScoreBadge({ score }) {
  return <Badge score={score}>{convertScoreToGrade(score)}</Badge>;
}



// WEBPACK FOOTER //
// ./src/app/feedback/ScoreBadge.js